import React from 'react';
import { ManageLandingPageEnquiriesContent } from '../components/Enquiries/ManageLandingPageEnquiriesContent';
import { ToastContainer } from 'react-toastify';
export const LandingPageEnquiry = () => {
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false}/>
                    <ManageLandingPageEnquiriesContent/>
                </div>
            </div>
        </div>
    )
}
